module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/logo-coj-th-33ae16f6688a445e1854eaf479f4b328.svg";